module.exports = __webpack_public_path__ + "img/oie-startsida-promo-01.jpg";